import type { IconProps } from './types';

export const StrikeThroughIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={color}
      className={className}
    >
      <path
        d="M15.4283 16.179C15.4283 15.9741 15.4108 15.7735 15.3766 15.5794L15.3365 15.387L15.3229 15.3108C15.2735 14.9342 15.5165 14.574 15.8942 14.4847C16.2721 14.3953 16.6506 14.6089 16.775 14.9681L16.7965 15.0423L16.8541 15.3186C16.9034 15.5983 16.9283 15.8862 16.9283 16.179C16.9281 18.9007 14.7215 21.1067 11.9996 21.1067C9.94967 21.1066 8.19369 19.8551 7.45081 18.0774L8.83459 17.4993C9.35241 18.7384 10.5756 19.6066 11.9996 19.6067C13.893 19.6067 15.4281 18.0723 15.4283 16.179ZM7.85413 17.097C8.23621 16.9374 8.67485 17.1173 8.83459 17.4993L7.45081 18.0774C7.29131 17.6953 7.47204 17.2566 7.85413 17.097ZM7.0719 7.82157C7.0719 5.09973 9.27785 2.89308 11.9996 2.89286C14.0511 2.89286 15.8083 4.14643 16.5504 5.92606C16.7096 6.30827 16.5293 6.74713 16.1471 6.90653C15.7648 7.06594 15.3251 6.88548 15.1656 6.50321C14.6484 5.26275 13.4247 4.39286 11.9996 4.39286C10.1063 4.39308 8.5719 5.92815 8.5719 7.82157C8.57197 9.71492 10.1063 11.2501 11.9996 11.2503H19.7145L19.7906 11.2542C20.169 11.2924 20.4645 11.6118 20.4645 12.0003C20.4643 12.3886 20.1689 12.7082 19.7906 12.7464L19.7145 12.7503H4.28577C3.87165 12.7503 3.53592 12.4144 3.53577 12.0003C3.53577 11.5861 3.87155 11.2503 4.28577 11.2503H8.46155C7.60171 10.3631 7.07194 9.15461 7.0719 7.82157Z"
        fill={color}
      />
    </svg>
  );
};
